/**
 * In some cases, we want to wrap the values for the test environment.
 * If we are in the test environment, value will be replaced with a test value.
 *
 * With this, we can optimise the performance of our tests and avoid flakiness.
 *
 * Examples:
 *  - something debounced to resolve immediately
 *  - something animated where we shorten the animation
 */
export class TestValueWrapper {
  private static wrapTestValues = true;

  static wrap<T>(value: T, testValue: T): T {
    if (process.env.IS_TEST && TestValueWrapper.wrapTestValues) {
      return testValue;
    }

    return value;
  }

  static turnWrappingOff(): void {
    TestValueWrapper.wrapTestValues = false;
  }
  static turnWrappingOn(): void {
    TestValueWrapper.wrapTestValues = true;
  }
}
